import { Fragment } from "react";
import { titleCase } from "change-case-all";
import { useSelector } from "react-redux";
import { Info } from "@mui/icons-material";
import styled from "styled-components";
import { Grid, IconButton, InputAdornment, MenuItem } from "@mui/material";

import {
  TextField,
  AutocompleteMultiSelect,
  FileUpload,
  ComponentHeader,
  Chip,
} from "../../../../components";
import { TextFourteenBlack, colors } from "../../../css components/Style";
import BrandDetailsDialog from "../../brand details components/BrandDetailsDialog";
import MUIDateTimePicker from "../../../../components/DateTimePicker";

const ImageDiv = styled.div`
  width: 286px;
  height: 120px;
  border: 1px solid #d6cbcb;
  border-radius: 10px;
`;

const Image = styled.img`
  height: 100%;
  width: 100%;
  object-fit: fill;
  border-radius: 10px;
`;

export default function FormOne({
  categories,
  formikProps,
  editState,
  brandIdentity,
  component,
  brandDetails,
  setBrandDetails,
}) {
  const onImageError = (e) => {
    e.target.src =
      "https://dc-chat-media.s3.ap-south-1.amazonaws.com/NaN_placeholder.png";
  };

  const { dashboardState } = useSelector((state) => state.memberDetails);

  return (
    <Fragment>
      <Grid size={12}>
        <ComponentHeader
          title="Campaign Details"
          buttons={[
            dashboardState === "SUPER_ADMIN" && (
              <Chip
                background={colors.green}
                label={`Platform Source - ${formikProps.values?.platformSource}`}
              />
            ),

            dashboardState === "SUPER_ADMIN" &&
              formikProps.values?.partnerName && (
                <Chip
                  background={colors.green}
                  label={`Partner - ${formikProps.values?.partnerName}`}
                />
              ),

            (formikProps.values?.status === "READY" ||
              formikProps.values?.status === "ACTIVE" ||
              formikProps.values?.status === "LIVE_REQUESTED") &&
              dashboardState !== "promotion" &&
              formikProps.values.Intersection_Audience !== null && (
                <Chip
                  background={colors.purple}
                  label={`Intersection Audience : ${formikProps.values.Intersection_Audience}`}
                />
              ),

            (formikProps.values?.status === "READY" ||
              formikProps.values?.status === "ACTIVE" ||
              formikProps.values?.status === "LIVE_REQUESTED") &&
              dashboardState !== "promotion" &&
              formikProps.values.cpm !== null && (
                <Chip
                  background={colors.purple}
                  label={`CPM : ${formikProps.values.cpm}`}
                />
              ),
          ]}
          subtitle={
            !formikProps.values.campaignID
              ? "Setup your campaign details"
              : titleCase(formikProps.values?.campaign_name?.value)
          }
        />
      </Grid>
      {!!formikProps.values.previewImage && (
        <Fragment>
          <Grid size={12}>
            <ImageDiv>
              <Image
                src={formikProps.values.previewImage}
                alt="!"
                onError={onImageError}
              />
            </ImageDiv>
          </Grid>
        </Fragment>
      )}
      {(component === "superadmin" || component === "accepted") && (
        <Fragment>
          <Grid size={4}>
            <TextField
              size="small"
              label="Brand Name"
              name="brandName"
              placeholder="Brand Name"
              value={brandDetails.data.brandName}
              disabled
              InputProps={{
                endAdornment: (
                  <InputAdornment position={"end"}>
                    <IconButton
                      onClick={() =>
                        setBrandDetails((prevVal) => ({
                          ...prevVal,
                          state: true,
                        }))
                      }
                      style={{ padding: "0" }}
                    >
                      <Info style={{ color: colors.purple }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
        </Fragment>
      )}
      <Grid size={4}>
        <TextField
          required
          name="campaign_name.value"
          placeholder="Campaign Name"
          label="Campaign Name"
          formikProps={formikProps}
          disabled={!editState}
          inputProps={{ maxLength: 50 }}
        />
      </Grid>

      <Grid size={4}>
        <TextField
          required
          select
          name="campaign_type.value"
          placeholder="Campaign Type"
          label="Campaign Type"
          formikProps={formikProps}
          disabled={!editState}
        >
          <MenuItem value="BRANDING">Branding</MenuItem>
          <MenuItem value="CONSIDERATION">Consideration</MenuItem>
          <MenuItem value="LEAD_GENERATION">Lead Generation</MenuItem>
          <MenuItem value="NOT_DEFINED">Not Defined</MenuItem>
        </TextField>
      </Grid>

      <Grid size={4}>
        <TextField
          required
          select
          name="query_type"
          placeholder="Query Type"
          label="Query Type"
          formikProps={formikProps}
          disabled={!editState}
        >
          <MenuItem value="and">And</MenuItem>
          <MenuItem value="or">Or</MenuItem>
        </TextField>
      </Grid>

      {!brandIdentity && (
        <Grid size={4}>
          <FileUpload
            required
            disabled={!editState}
            name="previewImage"
            formikProps={formikProps}
            placeholder="Select Preview Image"
            allowedExtension=".jpg,.jpeg,.png,.gif"
            value={formikProps.values.previewImage
              ?.split("/")
              .pop()
              .slice(
                formikProps.values?.previewImage
                  ?.split("/")
                  .pop()
                  .indexOf("_") + 1
              )}
            folderPath={"public/preview_images/" + new Date().getTime() + "_"}
          />
        </Grid>
      )}

      {(!brandIdentity ||
        component === "accepted" ||
        component === "superadmin") && (
        <Fragment>
          <Grid size={4}>
            <TextField
              required
              name="destination_url.value"
              formikProps={formikProps}
              placeholder="Campaign Destination URL"
              disabled={!editState}
              label="Campaign Destination URL"
            />
          </Grid>
        </Fragment>
      )}

      <Grid size={4}>
        <MUIDateTimePicker
          name="start_duration.value"
          formikProps={formikProps}
          label="Start Date"
          minDateTime={new Date()}
          disabled={!editState}
          alternate="startTime"
        />
      </Grid>
      <Grid size={4}>
        <MUIDateTimePicker
          name="end_duration.value"
          formikProps={formikProps}
          label="End Date"
          minDateTime={
            formikProps.values.start_duration.value
              ? (() => {
                  const start = new Date(
                    formikProps.values.start_duration.value
                  );
                  const end = new Date(formikProps.values.end_duration.value);

                  const isSameDay =
                    start.setHours(0, 0, 0, 0) === end.setHours(0, 0, 0, 0);

                  return isSameDay
                    ? new Date(
                        new Date(
                          formikProps.values.start_duration.value
                        ).getTime() +
                          30 * 60 * 1000
                      )
                    : new Date(formikProps.values.start_duration.value);
                })()
              : new Date()
          }
          disabled={!editState}
          alternate="endTime"
        />
      </Grid>

      {/* <Grid size={4}>
        <TextField
          required
          disabled={!editState}
          name="volume.value"
          placeholder="Desired Volume"
          formikProps={formikProps}
          label="Desired Volume"
          inputProps={{ type: "number" }}
        />

        {pagePermissions.display_credits && editState && component === "" && (
          <TextFourteenBlack style={{ color: "#333", opacity: "0.8" }}>
            NOTE: Desired Volume should be less than or equal to the credits
            {`(${creditDetails.coins})`}
          </TextFourteenBlack>
        )}
      </Grid>{" "} */}
      {/* <Grid size={4}>
        <TextField
          disabled={!editState}
          name="monthly_active_user.value"
          formikProps={formikProps}
          placeholder="Monthly Active Users"
          label="Monthly Active Users"
          inputProps={{ type: "number" }}
        />
      </Grid>
      <Grid size={4}>
        <AutocompleteMultiSelect
          required={false}
          label="Preferred Business Categories"
          name="category.value"
          forcePopupIcon={!editState ? false : true}
          formikProps={formikProps}
          defaults={{
            primaryKey: "name",
            displayLabel: "name",
          }}
          disabled={!editState}
          options={categories.filter((i) => i.id !== 31)}
          placeholder="Preferred Business Categories"
          onChange={(_, arr, reason, option) =>
            handleChange(arr, option, reason, "category.value", "name")
          }
        />
      </Grid>*/}
      <Grid size={4}>
        <TextField
          name="about.value"
          placeholder="About Campaign"
          multiline
          label="About Campaign"
          formikProps={formikProps}
          disabled={!editState}
          inputProps={{ maxLength: 255 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <span style={{ fontSize: 12, color: "#888" }}>
                  {`${formikProps.values.about.value.length}/255`}
                </span>
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />
    </Fragment>
  );

  function handleChange(arr, { option }, reason, name, displayName) {
    let objectName = name.substring(0, name.indexOf("."));

    formikProps.setValues((prevVal) => ({
      ...prevVal,
      [objectName]: setValuesOfDropDown(prevVal[objectName]),
    }));

    function setValuesOfDropDown(val) {
      let values = [...val.value];

      if (reason === "removeOption") {
        if (typeof option === "object") {
          values = values.filter((val) => val !== option[displayName]);
        }

        if (typeof option === "string") {
          values.pop();
        }
      }
      if (reason === "selectOption") {
        values.push(option[displayName]);
      }

      return {
        ...val,
        value: values,
      };
    }
  }
}
